import React, { useEffect } from 'react'
import H1P from '../../components/H1P'
import './Attributions.css'
import ScrollToTop from '../../components/ScrollToTop'

export default function Attributions() {
    useEffect(() => {
    document.title='Attributions | UCopenhagen'
    }, []);
    return(
        <div className='attributions-container'>
            <div className="team-picture">
                <img src="https://static.igem.wiki/teams/4247/wiki/attributions/copy-of-thank-you-nnf-2.svg" alt='Team UCopenhagen'/>
            </div>
            <H1P class={ 'thanks' } title={[<h1>Our project is made possible by the contributions that the people in this page have made.</h1>, <br></br>, <h1><big>We are very thankful for all the effort that they have put in!</big></h1>]}/>
            <div className="thanks">
                <h1>Our team</h1>
            </div>
            <div className="attributions supervisors">
                    <div className="box" id="matteo">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/matteo.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Matteo Soana</h1>
                            <h2>Wet Lab Coordinator</h2>
                            <p>Matteo was the Science coordinator responsible for the Wet Lab progress and conducting the experiments. Alongside Akila he led the literature research and design of protocols for our experiments. He was also a part of the Management team, helped write grant and funding applications.</p>
                        </div>
                    </div>
                    <div className="box" id="kim">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/kim.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Kim Dung Đặng</h1>
                            <h2>Human Practices Coordinator</h2>
                            <p>Kim as a Human Practice Coordinator alongside Srishti, was conducting interviews and leading team collaborations and partnership. She also helped out creating the Children’s book. Throughout the project she was also helping in the lab as a member of Wet Lab. Together with Pepa, they were the minds behind our business plan. </p>
                        </div>
                    </div>

            </div>
            <div className="attributions supervisors">
                    <div className="box" id="akila">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/akila.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Akila Ravikumar</h1>
                            <h2>Wet Lab Coordinator</h2>
                            <p>Akila was the Science coordinator responsible for Wet Lab. She, alongside Matteo, led the laboratory work, literature research and design of protocols for our experiments. She was also the creator of the Children's book.</p>
                        </div>
                    </div>
                    <div className="box" id="srishti">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/srishti.jpeg" alt=""/>
                        <div className="member-name">
                            <h1>Srishti Anil Singh</h1>
                            <h2>Human Practices Coordinator</h2>
                            <p>Srishti was the Human Practises coordinator alongside Kim, responsible for the collaborations and partnership. She organised and conducted all the interviews and meetings with external experts and stakeholders, while also being a part of the Wet Lab. She also assisted with the shoot and narrated our Project Promotion video and was a creator of the Children's book.</p>
                        </div>
                    </div>
            </div>
            <div className="attributions supervisors">
                    <div className="box" id="monica">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/monica.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Mònica Aguilà Sans</h1>
                            <h2>Management Coordinator</h2>
                            <p>Mònica was the Management coordinator alongside Zrinka, for the first half of the project; leading the team and writing grant applications and funding opportunities. For the second part of the project she focused on coding the Wiki and participated in the achievement of the Dry Lab by helping with modeling and design. She was also responsible for ensuring that the project did not lose focus of the UN Sustainable Development Goals.</p>
                        </div>
                    </div>
                    <div className="box" id="farraz">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/farraz.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Muhammad Farraz Syadzha</h1>
                            <h2>Wiki Coordinator</h2>
                            <p>Alongside Pepa, Farraz was also our Wiki coordinator and maestro, designing the Wiki and the guy behind the camera for the project Promotion video. He aided in experiments in the Wet Lab while also creating the Children's book for Education and Outreach.</p>
                        </div>
                    </div>
            </div>
            <div className="attributions supervisors">
                    <div className="box" id="joachim">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/joachim.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Joachim Alexis Ibsen</h1>
                            <h2>Dry Lab Coordinator</h2>
                            <p>Joachim was the Dry Lab coordinator and our modelling leader. He was also responsible for design of the spinning protocols in the Wet Lab. In addition he was also the one in charge of the Education and Outreach collaborations, creator of the Children's book, and the design master of the Pocket Lab, our online synthetic biology game.</p>
                        </div>
                    </div>
                    <div className="box" id="pepa">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/pepa.jpg" alt=""/>
                        <div className="member-name">
                            <h1>María José Romero Lado</h1>
                            <h2>Wiki Coordinator</h2>
                            <p>María José - aka Pepa, was the Wiki coordinator and maestro with Farraz, leading the Wiki coding and development while on her internship in the US. Once she came back she took over the role of leading the team in Management as well as supporting both Dry and Wet Lab. She was also the creator of the Children’s book, directed our Promotion video and was in charge of the business and sustainable parts of the project together with Kim and Mònica.</p>
                        </div>
                    </div>
            </div>
            <div className="attributions supervisors">
                    <div className="box" id="zrinka">
                        <img src="https://static.igem.wiki/teams/4247/wiki/team-pics/zrinka.jpg" alt=""/>
                        <div className="member-name">
                            <h1>Zrinka Tabain</h1>
                            <h2>Management Coordinator</h2>
                            <p>Alongside Mònica, Zrinka was the Management coordinator, leading the team, researching, writing and applying for funds and grants. With Pepa, she was overseeing the budget and reaching out to sponsors and seeking collaboration opportunities. She was also supporting the team in lab experiments for Wet and Dry Lab.</p>
                        </div>
                    </div>
            </div>

            <div className="thanks">
                <h1>Special thanks</h1>
                <br></br>
                <h3>We want to thank Malene Eskildsen for being a part of our team from the beginning, brainstorming, later on as the Dry Lab coordinator, and staying on for as long as she could.</h3>
            </div>    

            <div className="thanks">
                <h1>Supervisors and advisors</h1>
                <br></br>
                <h3>We would like to send special thanks to our supervisors and advisors from the Centre for Synthetic Biology and the Biochemical Engineering lab at the University of Copenhagen, who have continuously guided and supported us until the last day of our project.</h3>
                <br></br>
                <h2>Principal Investigators (PIs)</h2>
            </div>     
            <div className="attributions supervisors">
                <div className="box" id="sotirios">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-1-sotirios.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Sotirios Kampranis</h1>
                        <h2>Primary Principal Investigator</h2>
                        <h2>Professor, Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>With his many years of experience being part of the iGEM community, Sotirios was our main supervisor. He guided our brainstorming process and our lab progress. Many of the team instructors belong to the  Sotirios’ research group and have been of great help to us throughout the project. Besides the lab bench, Sotirios’ group provided us with training and guidance throughout the project.</p>
                    </div>
                </div>
                <div className="box" id="karel">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-2-karel.png" alt=""/>
                    <div className="member-name">
                        <h1>Karel Miettinen</h1>
                        <h2>Secondary Principal Investigator</h2>
                        <h2>Assistant professor, Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>Karel was always ready to help with our scientific planning and research, and he supervised our lab work. His advice and feedback was always truly helpful in both experiment progress and grant applications.</p>
                    </div>
                </div>	
            </div>

            <div className="thanks">
                <h2>Advisors</h2>
            </div> 
            <div className="attributions supervisors">
                <div className="box" id="nat">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-3-nat.jpeg" alt=""/>
                    <div className="member-name">
                        <h1>Nattawat Leelahakorn</h1>
                        <h2>PhD student at  Department of Plant and Environmental Sciences, University of Copenhagen and former iGEM member (PharMARSy 2018)</h2>
                        <p>Nat was a go-to person for everyday experiment progress while his advice and feedback helped us be on the right track. He supervised us when conducting new experiments and during long hours and long weekends.</p>
                    </div>
                </div>
                <div className="box" id="nanna">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-4-nanna.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Nanna Heinz</h1>
                        <h2>Centre coordinator at Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>Nanna was responsible for the team formation and early team building. She introduced us to the iGEM world and the iGEM spirit. She led the team meetings through brainstorming phases and prepared us to be our own, creating meeting schedules, subgroups and project development. Nanna also helped us with all administrative work as well as HR, was our link to the department, and provided us with support throughout the project.</p>
                    </div>
                </div>	
            </div>
            <div className="attributions supervisors">
                <div className="box" id="anett">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-5-anett.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Anett Stéger</h1>
                        <h2>PhD student at the Department of Plant and Environmental Sciences, University of Copenhagen and former iGEM member (Ovulaid 2019)</h2>
                        <p>Anett has continuously provided us with valuable feedback on all aspects of our project, from lab experiments and human practices approach to internal organisation and presentation skills. She was also our link to the former and current members of the iGEM community, helping us with modelling, outreach materials and funding.</p>
                    </div>
                </div>
                <div className="box" id="daniel">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-6-daniel.png" alt=""/>
                    <div className="member-name">
                        <h1>Daniel Poveda Huertes</h1>
                        <h2>Postdoc at Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>Daniel has always provided us with great advice on our ideas, has supervised our experiments while also provided feedback on presenting and outreach materials.</p>
                    </div>
                </div>	
            </div>

            <div className="thanks">
                <h1>Faculty support</h1>
            </div> 

            <div className="attributions supervisors">
                <div className="box" id="jette">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-7-jette.jpg" alt="" width="300" height="500"/>
                    <div className="member-name">
                        <h1>Jette Højgård</h1>
                        <h2>Section Secretary, Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>She helped us with all the administrative work, especially for booking the flight tickets and accomodation for Paris for the Grand Jamboree as well as Sweden for the Nordic iGEM Conference..</p>
                    </div>
                </div>

                <div className="box" id="tilla">
                    <img style={{height:'35%'}} src="https://static.igem.wiki/teams/4247/wiki/attributions/image-8-tilla.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Tilla Augusta Engelsted</h1>
                        <h2>Laboratory Coordinator,  Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>She taught us the importance of safety in the laboratory and the good practices needed to work in synthetic biology.</p>
                    </div>
                </div>	
            </div>

                <div className="attributions supervisors">
                <div className="box" id="birger">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-9-birger.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Birger Lindberg Møller</h1>
                        <h2>Professor and Head of the Center for Synthetic Biology, University of Copenhagen</h2>
                        <p>Birger shared his excitement about synthetic biology and the limitless possibilities it offers. He provided us with great feedback during our project.</p>
                    </div>
                </div>

                <div className="box" id="johan">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-10-johan.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Johan Andersen-Ranberg</h1>
                        <h2>Assistant professor, Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>He was one of the first professors to teach us about the possibilities of synthetic biology, even outside of Earth.</p>
                    </div>
                </div>
                </div>	

                <div className="attributions supervisors">
                <div className="box" id="kirsten">
                    <img style={{height:'35%'}} src="https://static.igem.wiki/teams/4247/wiki/attributions/image-11-kirstenjpg.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Kirsten Jørgensen</h1>
                        <h2>Asst. Professor and Vice Head of Department for Teaching, Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>We want to thank Kirsten for her support during the project development.</p>
                    </div>
                </div>
                <div className="box" id="iben">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-12-iben-nikolajsen-bw.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Iben Egebæk Nikolajsen</h1>
                        <h2>EY consultant and also former iGEM member (Ovulaid 2019)</h2>
                        <p>Iben helped us to understand how to write grant applications and laid a foundation on which we built further.</p>
                    </div>
                </div>	
                </div>	

                <div className="attributions supervisors">
                <div className="box" id="attila">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-13-atilla.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Attila Uslu</h1>
                        <h2>Pilot Scientist at Novo Nordisk, former iGEM team member (PharMARSy, 2018)</h2>
                        <p>His input in the meetings at the beginning of the group formation and in the information sessions was highly valuable for the team.</p>
                    </div>
                </div>
                <div className="box" id="emil">
                    <img src="https://static.igem.wiki/teams/4247/wiki/attributions/image-14-emil.jpg" alt=""/>
                    <div className="member-name">
                        <h1>Emil Funk</h1>
                        <h2>Masters student, former iGEM team member (CIDosis 2020)</h2>
                        <p>Emil gave us useful input in the phase of choosing the ideas, as well as contacts with whom we could establish connections.</p>
                    </div>
                </div>	
                </div>

                <div className="attributions supervisors">
                <div className="box" id="sotirios">
                    <img style={ {height:'40%'}} src="https://static.igem.wiki/teams/4247/wiki/attributions/image-irini-15.jpeg" alt=""/>
                    <div className="member-name">
                        <h1>Irini Petraki</h1>
                        <h2>Assistant professor, Department of Plant and Environmental Sciences, University of Copenhagen</h2>
                        <p>She helped us process our sequencing files throughout the project.</p>
                    </div>
                </div>
                </div>
                
            <div className="thanks">
                <h1>Human Practices</h1>
            </div>

            <div className="hp-thanks">
                <h2>Eva Maria Pedersen</h2>
                <h3>Senior consultant at National Institute of Aquatic Resources, Technical University of Denmark</h3>
                <p>She provided us with invaluable information and insight on the current state of the ghost nets in the Danish water and the problem they pose in a wider context. She provided great feedback on our project and guided us further to reach out to specific people related to our project.</p>
                <br></br>
                <h2>Paul Müller</h2>
                <h3>PhD student at the University of  Hamburg</h3>
                <p>Paul was crucial in connecting us to a wider community of fishermen and sharing their insights with us, even conducted interviews with the German brown shrimp fishermen.</p>
                <br></br>
                <h2>Sofie Smedegaard Mathiasen</h2>
                <h3>Danish Fishermen Producer Organisation (DFPO)</h3>
                <p>Sofie discussed the problem that lost fishing gear and nets pose as well as guided our project into the flexibility it has. Since fishermen require various characteristics of the net dependent on the targeted catch, we included that into the project by making our fibres modifiable for various possibilities.</p>
                <br></br>
                <h2>Esther Savina</h2>
                <h3>DTU Aqua</h3>
                <p>Esther guided us in our brainstorming on fibre functionalities and provided useful feedback on the concept of biodegradable nets and materials. She gave us a lot of information about the other materials that have been tested or are currently being tested to be used as alternatives for nylon nets.</p>
                <br></br>
                <h2>Thomas Kirk Sørensen</h2>
                <h3>Coordinator of Ocean Life in World Wildlife Fund (WWF) Copenhagen</h3>
                <p>Thomas provided us with inputs about the problem ghost nets pose and their impact on millions of people that rely their livelihoods on fishing. He also explained the importance of sustainable fishing and provided us with further contacts of experts that we reached out to.</p>
                <br></br>
                <h2>Helle Christensen</h2>
                <h3>Fisheries Outreach Manager, Scandinavia and Baltic Sea Region – Marine Stewardship Council (MSC)</h3>
                <p>Helle told us about the ongoing pursuit of making a mandatory certification as a standard for sustainable seafood and fisheries. We discussed the issues at hand with control and supervision of the fishing gear however the MSC offers a good start for a solution for the future of sustainable fishing.</p>
                <br></br>
                <h2>Andrea Stolte</h2>
                <h3>Ghost nets project in the Baltic sea coordinator in WWF Germany</h3>
                <p>Andrea helped us immensely and her inputs were crucial for our idea development as she emphasised the problem we are addressing, gave feedback on fishing gear and previous unsuccessful attempts of developing biodegradable fishing equipment which guided us in the right direction. </p>
                <br></br>
                <h2>Sune Hannibal Holm</h2>
                <h3>Associate Professor, University of Copenhagen </h3>
                <p>Sune helped us by giving really detailed insights that we used to create the children’s activity book. He also helped us learn the various ethical aspects and considerations that need to be made while communicating about synthetic biology, our project, and GMO in general. </p>
                <br></br>
                <h2>Sabarinath Karoor</h2>
                <h3>Senior Global Marketing Manager - Baking, Novozymes</h3>
                <p>Sabarinath had an insightful conversation with us about uses of GMO,the ethical concerns regarding using GMOs to develop a new product, and the consumers' perspectives and how it is crucial to educate the wider audience about GMOs.</p>
                <br></br>
                <h2>Peter Hvass</h2>
                <h3>Senior Science Manager, Novozymes</h3>
                <p>Peter also told us about the GM-technology and ethical concerns valuable for our production stage and regulatory level and considerations in products made with GMOs which are not a GMO themselves. </p>
                <br></br>
                <h2>Nima Sophia Tisdall</h2>
                <h3>Blue Lobster</h3>
                <p>Nima provided the most useful insights in entrepreneurship and business model development as well as gave advice on start-up business. She even gave an understanding of the fishermen's perspective as she works with them closely for her start-up Blue Lobster. Fishermen- Kumar & Sekar from India, Brown shrimp fishermen from Germany, Zhe Gu, Jing Li, Haifeng Zhang, Zhibin Sun from China, Emanuele Pensotti from Italy. All the fishermen were really sweet and polite to talk to us and they narrated their fishing experiences to us. They also told us their opinions about our product and the challenges they face as fishermen. They discussed with us the properties they desire in a net.</p>
            </div>
            
            <div className="thanks">
                <h1>Outreach</h1>
            </div>

            <div className="hp-thanks">
                <h2>Astra Science talents camp</h2>
                <h3>Ida Lauritsen</h3>
                <p>Helped us to make a presentation at two of the Astra Science Talents biotechnology camps.</p>
                <br></br>
                <h2>POP UP LAB</h2>
                <h3>Catalina Oana Mihai and the entire Pop Up Lab team, special thanks to Troel Andersen Kjær, Julius Ingemann Breitensten and Clara Nessi</h3>
                <p>Big thank you for a great collaboration to organise, plan and execute our event.</p>
                <br></br>
                <h2>Snabslanten</h2>
                <p>A heartfelt thank you for funding our team for the POP UP LAB collaboration event.</p>
                <br></br>
                <h2>KBH+ ASKOVFONDEN</h2>
                <p><b>Stine Hamburgers, director of KBH+ </b> a huge thank you and gratitude for providing us with the free venue for the POP UP LAB event and managing the venue on the day of the event and <b> Maria Natascha Koustrup Laresen</b>, community manager for helping us to organise the event at the beautiful venue</p>
                <br></br>
                <h2>IDA-Danish Society of Engineers:</h2>
                <h3>Anne Dalgaard</h3>
                <p>Helped us organise the venue and prepare for the event.</p>
                <h3>Katharina Laungaard</h3>
                <p>She helped us with hosting our event on the day and logistics.</p>
                <h3>Mikkel Sandal Hansen</h3>
                <p>Aided our efforts to secure funding.</p>
            </div>

            <div className="thanks">
                <h1>Schools</h1>
            </div>
            
            <div className="hp-thanks">
            <h2>CEIP San Ignacio (Ecoescuela)</h2>
            <h3>José Luis Romero Vázquez</h3>
            <p>Organised an SDG workshop and provided feedback on the Spanish translation of the book to improve it.</p>
            <br></br>
            <h2>CEIP San Rafael (Ecoescuela)</h2>
            <h3>Isabel María Lado Gómez</h3>
            <p>Organised workshops for elementary school children on materials and building the nets of those materials found in nature, while also using the Childrens book.</p>
            <br></br>
            <h2>Roskilde Gymnasium</h2>
            <h3>Ida Thingstrup and Christine Brænder Almstrup</h3>
            <p>Helped us host a presentation for their students in biotechnology as well as help test-run the computer game with those students.</p>
            </div>

            <div className="thanks">
                <h1>Collaborations and Partnerships</h1>
            </div>

            <div className="hp-thanks">
            <h3>We want to thank all iGEM teams that we collaborated with for mutual benefit in all of our project developments:
                <a href='https://2022.igem.wiki/mit-mahe/index.html' target={'_blank'} rel='noreferrer' className='page-links'>iGEM MIT MAHE 2022</a>, <a href='https://2022.igem.wiki/nthu-taiwan/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM NTHU 2022</a> , <a href='https://2022.igem.wiki/waterloo/' target={'_blank'} rel='noreferrer' className='page-links'>Waterloo iGEM 2022</a>, <a href='https://2022.igem.wiki/asij-tokyo/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM ASIJ Tokyo 2022</a>, <a href='https://2022.igem.wiki/uppsala/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Uppsala 2022</a>, <a href='https://2022.igem.wiki/ccu-taiwan/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM CCU Taiwan</a>, <a href='https://2022.igem.wiki/crete/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Crete</a>, <a href='https://2022.igem.wiki/aalto-helsinki/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Aalto-Helsinki</a>, <a href='https://2022.igem.wiki/duesseldorf/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Düsseldorf</a>, <a href='https://2022.igem.wiki/thessaloniki/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Thessaloniki</a>, <a href='https://2022.igem.wiki/msp-maastricht/' target={'_blank'} rel='noreferrer' className='page-links'>Maastricht iGEM</a>, <a href='https://2022.igem.wiki/thessaloniki-meta/' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Methathess</a>, <a href='https://2022.igem.wiki/rec-chennai' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Rec Chennai</a>, <a href='https://2022.igem.wiki/dtu-denmark' target={'_blank'} rel='noreferrer' className='page-links'>iGEM DTU Biobuilders</a>, <a href='https://2022.igem.wiki/patras-medicine' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Patras Med</a>, <a href='https://2022.igem.wiki/tudelft' target={'_blank'} rel='noreferrer' className='page-links'>iGEM TU Delft</a>, <a href='https://2022.igem.wiki/stockholm' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Stockholm</a>, <a href='https://2022.igem.wiki/lund' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Lund</a>, <a href='https://2022.igem.wiki/aboa' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Aboa</a>, <a href='https://2022.igem.wiki/uioslo-norway' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Oslo</a>, <a href='https://2022.igem.wiki/chalmers-gothenburg' target={'_blank'} rel='noreferrer' className='page-links'>iGEM Chalmers Gothenburg</a>, <a href='https://2022.igem.wiki/linkoping-sweden' target={'_blank'} rel='noreferrer' className='page-links'>iGEM LiU</a>, <a href='https://2022.igem.wiki/nnu-china' target={'_blank'} rel='noreferrer' className='page-links'>iGEM NNU-China</a></h3>
            </div>

            <div className="thanks">
                <h1>Partnership</h1>
            </div>

            <div className="hp-thanks">
            <h3>We want to thank the iGEM teams, iGEM EPFL and iGEM Vienna, for the great partnership throughout the course of our projects! We were helping each other by sharing best practices in wet lab and precise protocols related to spider silk. </h3>
            </div>

            <div className="thanks">
                <h1>Wet Lab</h1>
                <br></br>
                <h3>We would like to specially thank everyone at the Department of Plant and Environmental Sciences (PLEN) for their inputs, advice and time given to show us new techniques, their laboratories we used and their continued help whenever needed. </h3>
            </div>

            <div className="hp-thanks">
                <h2>Anna Rising</h2>
                <h3>Researcher at Karolinska Institute and professor of veterinary medical biochemistry at SLU</h3>
                <p>Anna provided useful feedback on protein concentration protocols.</p>
                <br></br>
                <h2>Markus Linder</h2>
                <h3>Aalto University</h3>
                <p>Markus helped us kick start the project, introduced us to spider silk proteins and their production.</p>
                <br></br>
                <h2>Quinn Kalby Heck</h2>
                <h3>Research assistant at Department of Plant and Environmental Sciences, University of Copenhagen</h3>
                <p>Helped us with using and running the fermenter.</p>
                <br></br>
                <h2>Feiyan Liang </h2>
                <h3>Postdoc at Department of Plant and Environmental Sciences, University of Copenhagen</h3>
                <p>Guided us with general instructions, answering our questions and helped us with ordering necessary primers.</p>
                <br></br>
                <h2>Demi Tristan Djajadi</h2>
                <h3>Postdoc at Department of Geosciences and Natural Resource Management, University of Copenhagen</h3>
                <p>Helped with finding the right machine for analysing the fibres, and gave ideas for strengthening the fibres. </p>
                <br></br>
                <h2>Anand Ramesh Sanadi</h2>
                <h3>Associate Professor at  Department of Geosciences and Natural Resource Management, University of Copenhagen</h3>
                <p>Anand aided us to plan out the best way to measure the strength of the fibres.</p>
                <br></br>
                <h2>Jack Olsen</h2>
                <h3>Laboratory Technician at PLEN, University of Copenhagen</h3>
                <p>We want to thank Jack for sharing the spinning apparatus with us.</p>
                <br></br>
                <h2>Howarth Lab</h2>
                <p>In addition, we send a big thank you to the people of Howarth Lab, the minds behind the Tag-Catcher technologies. Not only they invented the system, they also made it available to all through their repository, allowing us to develop our proof of concept.</p>
            </div>

            <div className="thanks">
                <h1>Dry Lab</h1>
            </div>

            <div className="hp-thanks">
                <h2>Kristoffer Almdal</h2>
                <h3>Professor, DTU Chemistry</h3>
                <p>Kristoffer guided us in the modelling process of biodegradability and durability of our nets.</p>
                <br></br>
                <h2>Kresten Lindorff-Larsen</h2>
                <h3>Professor, Department of Biology, University of Copenhagen</h3>
                <p>Advised us on modelling of intrinsically disordered proteins. </p>
                <br></br>
                <h2>Aleksandra Panfilova</h2>
                <h3>PhD fellow, University of Copenhagen</h3>
                <p>Provided useful advice on how to approach our model ideas. </p>
                <br></br>
                <h2>Mads Rosenfeldt</h2>
                <h3>MSc Biotechnology</h3>
                <p>Provided useful advice on how to approach our model ideas. </p>
            </div>

            <div className="thanks">
                <h1>Wiki</h1>
            </div>

            <div className="hp-thanks">
                <h2>Aje al-Awssi & Claudia Lassen</h2>
                <h3>Former iGEM team-members: Cidosis (2020) & Ovulaid (2019)</h3>
                <p>Introduced us to Wiki and shared their experiences and tips and tricks for Wiki development. </p>
            </div>

            <div className="thanks">
                <h1>Entrepreneurship</h1>
            </div>

            <div className="hp-thanks">
                <h2>Frederik Nygaard</h2>
                <h3>Science Innovation Hub</h3>
                <p>Frederik provided advice and feedback on developing our business plan.</p>
                <br></br>
                <h2>Sònia González García</h2>
                <h3>Universitat Autònoma de Barcelona</h3>
                <p>Sònia helped us design the business plan and research the market for our product  to estimate the fishing resources in figures. She also helped us to look into patents and intellectual property rights.</p>
                <br></br>
                <h2>Jùlia Palma & Meritxell Cardùs</h2>
                <h3>Parc de Recerca UAB</h3>
                <p>Jùlia & Meritxell helped us in quantifying our problem, as well as identifying the possible market opportunities for our product.</p>
                <br></br>
                <h2>Gigi Wang</h2>
                <h3>University of Berkeley</h3>
                <p>Gigi gave us an insight into the entrepreneurship of our project in terms of business strategies, go-to market plans as well as pitching and presentation techniques. With her feedback, we were able to develop an improved business plan and modify our business idea to be more feasible.</p>                <br></br>
                <h2>Josefine Lange Strandgaard</h2>
                <h3>Innovation Centre Denmark in Silicon Valley</h3>
                <p>Josefine introduced us to regulations and how to enter various international markets, with emphasis on the US market. </p>
            </div>

            <H1P class={ 'thanks' } title={'We would also like to thank our friends and family members for their support in us and our project!'}/>

            <ScrollToTop/>
            </div>    
    )
}